import { RequestBasePageIds, RequestBaseSet, RequestDeleteIds, ResponseBasePage, ResponseBaseSet } from "src/app/modules/fwcore/models";
import { RateHeader } from "src/app/features/prob/models";


export class RequestRateHeader extends RequestBasePageIds {

  /**
 * The identifier of the deal item for which rate headers are being requested.
 */
  dealItemId?: string | null = null;   

  /**
 * The identifier of the deal Id.
 */
  dealId?: string | null = null;   
  /**
   * The identifier of the dealtype id for which headers are being requested.
   */
  dealTypeId?: string | null = null;

  /**
   * The identifier of the rate for which headers are being requested.
   */
  rateId?: string | null = null;

  /**
   * The identifier of the tower for which headers are being requested.
   */
  towerId?: string | null = null;

}

export class ResponseRateHeader extends ResponseBasePage<RateHeader>
{
}

export class RequestRateHeaderSet extends RequestBaseSet<RateHeader>
{
}

export class ResponseRateHeaderSet extends ResponseBaseSet<RateHeader>
{
} 
export class RequestRateHeaderDelete extends RequestDeleteIds {

  hardDelete?: boolean | null;
}
